import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class VisualizationProvider {
  getCountriesVisualization() {
    return graphqlClient.query({
      query: gql`
        query country {
          country {
            id
            name
            consensusReport
            consensusReportResult
            dataVisualization
            dataVisualizationFilter
            forecastFilter
            consensusReportFilter
          }
        }
      `,
    });
  }

  getVariableVisualization(id) {
    return graphqlClient.query({
      query: gql`
        query country($country: Int!) {
          variable(country: $country) {
            name
            consensusReport
            consensusReportResult
            dataVisualization
          }
        }
      `,
      variables: {
        country: id,
      },
    });
  }

  gerData(country, variable) {
    return graphqlClient.query({
      query: gql`
        query visualization($country: String!, $variable: String!) {
          visualization(country: $country, variable: $variable) {
            data
          }
        }
      `,
      variables: {
        country,
        variable,
      },
    });
  }
}

export default new VisualizationProvider();
